import request from '@/utils/request'

const urlPrefix = '/event-sources'

export function getEventSourceList (params) {
  return request.get(urlPrefix, { params })
}

export function getEventSource (id) {
  return request.get(`${urlPrefix}/${id}`)
}

export function createEventSource (data) {
  return request.post(urlPrefix, data)
}

export function updateEventSource (id, data) {
  return request.put(`${urlPrefix}/${id}`, data)
}

export function deleteEventSource (id) {
  return request.delete(`${urlPrefix}/${id}`)
}
